module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('App-SideMenu'), _vm._v(" "), _c('main', {
    staticClass: "cd-main-content"
  }, [_c('div', {
    staticClass: "landing-main-content"
  }, [_c('div', {
    staticClass: "book-bg"
  }, [_c('div', {
    staticClass: "wrapper-square"
  }, [_c('div', {
    staticClass: "login-form-wrapper"
  }, [_c('div', {
    staticClass: "login-form-content"
  }, [_c('h1', [_vm._v("My Account")]), _vm._v(" "), _c('div', {
    staticClass: "login-input-containers"
  }, [_c('h3', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("EMAIL : ")]), _vm._v(" "), _c('h4', [_vm._v(" " + _vm._s(this.email) + " ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("My Read History")]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "log"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._l((_vm.logs), function(log) {
    return _c('tr', {
      key: log.id
    }, [_c('td', [_c('img', {
      attrs: {
        "src": _vm.$store.state.urlLink + log.bookId + '.png'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.bookName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.count))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button",
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "id": log.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    }, [_c('span', [_vm._v("Read")])])])])
  })], 2)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Book")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Opened")]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6af8a390"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/MyAccount.vue
// module id = 1698
// module chunks = 1